'use client'

import React, { HTMLAttributes } from 'react'

import { cn } from '@podo-app/design-system-temp'

interface GridProps extends HTMLAttributes<HTMLDivElement> {
  columns?: 1 | 2 | 3 | 4 | 6 | 12
  gap?: 'sm' | 'md' | 'lg' | 'xl'
  responsive?: boolean
  children: React.ReactNode
}

const Grid = ({ columns = 1, gap = 'md', responsive = true, className, children, ...props }: GridProps) => {
  const columnClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
    6: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6',
    12: 'grid-cols-4 md:grid-cols-6 lg:grid-cols-12',
  }

  const nonResponsiveColumnClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    6: 'grid-cols-6',
    12: 'grid-cols-12',
  }

  const gapClasses = {
    sm: 'gap-[5px]',
    md: 'gap-2.5',
    lg: 'gap-[15px]',
    xl: 'gap-5',
  }

  return (
    <div
      className={cn(
        'grid w-full',
        responsive ? columnClasses[columns] : nonResponsiveColumnClasses[columns],
        gapClasses[gap],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default Grid
